import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _enabledCSS, _disabledCSS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// exposed for testing purposes
export var enabledCSS = (_enabledCSS = {}, _defineProperty(_enabledCSS, '&:hover [data-custom-icon]', {
  display: 'none'
}), _defineProperty(_enabledCSS, '&:active [data-custom-icon]', {
  display: 'none'
}), _defineProperty(_enabledCSS, '&:focus [data-custom-icon]', {
  display: 'none'
}), _defineProperty(_enabledCSS, '& [data-custom-icon]', {
  display: 'inherit'
}), _defineProperty(_enabledCSS, '&:hover [data-right-arrow]', {
  display: 'inherit'
}), _defineProperty(_enabledCSS, '&:active [data-right-arrow]', {
  display: 'inherit'
}), _defineProperty(_enabledCSS, '&:focus [data-right-arrow]', {
  display: 'inherit'
}), _defineProperty(_enabledCSS, '& [data-right-arrow]', {
  display: 'none'
}), _enabledCSS);
var disabledCSS = (_disabledCSS = {}, _defineProperty(_disabledCSS, '[data-item-elem-after]', {
  opacity: 0
}), _defineProperty(_disabledCSS, '& [data-right-arrow]', {
  display: 'none'
}), _disabledCSS);
export var nestingItemStyle = function nestingItemStyle(state) {
  return _objectSpread({}, state.isDisabled ? disabledCSS : enabledCSS);
};